"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MachineIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _svg = _interopRequireDefault(require("./svg"));

require("./machine-badge.less");

require("./machine-badge-rebrand.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Renders a machine icon (typically shown next to its name or serial) based on
 * model.
 *
 * Usage:
 *
 *  <MachineIcon model='<basic|plus|pro>' />
 *
 */
var MachineIcon = function MachineIcon(props) {
  return /*#__PURE__*/_react["default"].createElement(_svg["default"], {
    id: "badge-icon-".concat(_lodash["default"].toLower(props.model))
  });
};

exports.MachineIcon = MachineIcon;
MachineIcon.propTypes = {
  model: _propTypes["default"].string
};
MachineIcon.defaultProps = {
  model: 'basic'
};
/**
 * Renders a machine badge (typically shown next to its name or serial) based on
 * model.
 *
 * Usage:
 *
 *  <MachineBadge model='<basic|plus|pro>' />
 *
 */

var MachineBadge = function MachineBadge(props) {
  var model = _lodash["default"].toLower(props.model);

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "MachineBadge ".concat(model, "-model uic")
  }, /*#__PURE__*/_react["default"].createElement(MachineIcon, {
    model: model
  }), /*#__PURE__*/_react["default"].createElement("span", null, model));
};

MachineBadge.propTypes = MachineIcon.propTypes;
MachineBadge.defaultProps = MachineIcon.defaultProps;
var _default = MachineBadge;
exports["default"] = _default;